module.exports = __webpack_public_path__ + "img/lotto.ca07c5a9.png";